<template>
  <button
    class="flex w-full items-center justify-between space-x-2"
    type="button"
    @click="emit('click-transaction', transaction)"
  >
    <div class="flex flex-1 flex-col items-start">
      <div class="mb-1">
        <template
          v-if="transaction.status === 'successful'"
        >
          <PaymentDetailChip :payment="transaction" />
        </template>
        <template v-else>
          <p class="text-error font-semibold">
            <template
              v-if="transaction.status === 'cancelled'"
            >
              Cancelled
            </template>
            <template
              v-else-if="transaction.status === 'failed'"
            >
              Failed
            </template>
            <template
              v-else-if="transaction.status === 'voided'"
            >
              VOIDED
            </template>
          </p>
        </template>
      </div>
      <div class="text-background-fg/70 text-xs">
        {{ formattedDate }}
      </div>
    </div>
    <div class="flex flex-col items-end">
      <p class="font-semibold">
        {{
          formatToCurrencyString(
            transaction.amountTransactedTotal,
            transaction.currency
          )
        }}
      </p>

      <p
        v-if="
          transaction.amountTransactedGratuity ||
          transaction.amountCashback
        "
        class="text-background-fg/70 text-xs"
      >
        (inc.
        <template
          v-if="transaction.amountTransactedGratuity"
        >
          gratuity
          {{
            formatToCurrencyString(
              transaction.amountTransactedGratuity,
              transaction.currency
            )
          }}
        </template>
        <template
          v-if="
            transaction.amountTransactedGratuity &&
            transaction.amountCashback
          "
          >,</template
        >
        <template v-if="transaction.amountCashback">
          cashback
          {{
            formatToCurrencyString(
              transaction.amountCashback,
              transaction.currency
            )
          }}
        </template>
        )
      </p>
    </div>
  </button>
  <ol>
    <template
      v-for="refund in transaction.refunds"
      :key="refund.id"
    >
      <li class="w-full">
        <button
          class="flex w-full items-center justify-between py-2 pl-4 pr-8"
          type="button"
          @click="emit('click-transaction', refund)"
        >
          <div class="flex flex-1 flex-col items-start">
            <p class="text-sm font-semibold">
              Refund
              <span
                v-if="refund.status === 'voided'"
                class="text-error"
              >
                (VOIDED)
              </span>
            </p>
            <div class="text-background-fg/70 text-xs">
              {{
                DateFns.format(
                  refund.createdAt,
                  "HH:mm dd/MM/yy"
                )
              }}
            </div>
          </div>

          <div>
            <p class="text-error text-sm font-semibold">
              -
              {{
                formatToCurrencyString(
                  refund.amountTransactedTotal,
                  transaction.currency
                )
              }}
            </p>
          </div>
        </button>
      </li>
    </template>
  </ol>
</template>

<script setup lang="ts">
import type {
  TransactionDetail,
  Refund,
} from "@/services/sharedTypes/transactions"
import * as DateFns from "date-fns"

const props = defineProps<{
  transaction: TransactionDetail
}>()

const emit = defineEmits<{
  (
    event: "click-transaction",
    params: TransactionDetail | Refund
  ): void
}>()

const { formatToCurrencyString } = useCurrency()

const formattedDate = computed(() =>
  DateFns.format(
    props.transaction.createdAt,
    "HH:mm dd/MM/yy"
  )
)
</script>
